module.exports = __webpack_public_path__ + "static/media/annaluke_engagement-62-min.2c58aec1.jpg";